<template>
<div>

  <el-dialog width="700px"
             title="短信购买"
             :visible.sync="viewDetail"
             @close="closeModel">
    <div class="selpay">
      <div class="btn">
        <el-button class="selwx"
                   :type="selVal == 2 ? 'success' : ''"
                   round
                   @click="selBtn(2)"> <i class="icon-weixinzhifu iconfont"></i> 微信支付</el-button>
        <el-button class="selali"
                   :type="selVal == 1 ? 'primary' : ''"
                   round
                   @click="selBtn(1)"> <i class="icon-zhifubaozhifu iconfont"></i> 支付宝支付</el-button>
      </div>
      <div class="erweima right">
        <div class="img">
          <div class="div"
               v-loading="urlLoad"
               element-loading-text="加载中"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
            <vue-qr :text="qrUrl"
                    qid="testid"
                    :margin="0"
                    v-if="qrUrl"></vue-qr>
            <div class="block"
                 v-else>
              <el-image>
                <div slot="error"
                     class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </div>
        <p>请使用{{ selVal == 2 ? "微信" : "支付宝" }}支付，支付成功后自动开通服务</p>
      </div>
    </div>
  </el-dialog>
      <div v-if="payVisible">
      <payResult @handleClose='inithandleClose'
                 :title='title'
                 :order_amount='order_amount'
                 :order_sn='order_sn'
                 :code='code'
                 :formCode='formCode'
                 ></payResult>
    </div>
</div>
</template>

<script>
import VueQr from "vue-qr";
import payResult from './payResult.vue'
import {
  mapActions,
  mapGetters
} from "vuex";
export default {
  props: ['id', 'combo_id', 'price_id'],
  data () {
    return {
      urlLoad: false,
      qrUrl: "",
      timer: null,
      viewDetail: false,
      selVal: 1,
      type: this.selVal, //支付类型 1-支付宝 2-微信
      order_amount: "",
      title: "",
      order_sn: "",
      code: "",
       payVisible:false,
       formCode:3
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    ...mapActions({
      applicationOrder: "activity/applicationOrder",
      getPayment: "activity/getPayment",
      getPayQuery: "activity/getPayQuery",
    }),
      inithandleClose(){
  this.payVisible = false
},
    selBtn (tag) {
      this.selVal = tag;
      clearInterval(this.timer)
      this.getPayId(this.combo_id,this.id);
    },
    closeModel () {
      this.viewDetail = false
      clearInterval(this.timer);
    },
    getPayId (combo_id, id, price_id) {
      let params = {
        token: this.getToken,
        id: id, //应用ID
        type: this.selVal, //支付类型 1-支付宝 2-微信
        price_id: price_id, //价格id
        combo_id: combo_id, //套餐id
      };
      this.urlLoad = true;
      this.applicationOrder(params).then(({
        data
      }) => {
        if (data.code == 1) {
          /*  if (data.data.payment_id == 0) {
              this.$emit("init");
             this.payVisible = true
             this.title = '支付成功'
             this.closeModel();
             return;
           } */
          this.Pay(data.data.payment_id);
        } else {
          this.$message.error(data.msg);
          this.urlLoad = false;
        }
      });
    },
    Pay (id) {
      this.getPayment({
        id: id
      }).then(({
        data
      }) => {
        this.urlLoad = false;
        if (data.code == 1) {
          this.qrUrl = data.data.pay_url;
          if (!data.data.pay_url) {
            this.$message.warning("已提交过申请，请等待审核！");
            //  this.imgDialog = false;
          } else {
            this.qrUrl = data.data.pay_url;
            this.urlLoad = false;
            let i = 0;
            this.timer = setInterval(() => {
              this.checkPay(id);
              i++;
              if (i >= 20) {
                clearInterval(this.timer);
              }
            }, 3000);
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    checkPay (id) {
      let opt = {
        id: id,
        token: this.getToken,
      };
      this.getPayQuery(opt).then(({
        data
      }) => {
        if (data.code == 1) {
       
          if (data.data.status == 1) {
            clearInterval(this.timer);
            this.viewDetail = true
            this.title = '支付成功'
            this.payVisible = false;
            this.order_amount = data.data.amount
            this.order_sn = data.data.order_sn
            this.code = data.data.code
            /* this.$emit("init"); */
          } else if (data.data.status == 3) {
            clearInterval(this.timer);
            this.payVisible = true
            /*  
 
 
              */
            this.title = '支付失败！'
            this.order_amount = data.data.amount
            this.order_sn = data.data.order_sn
            this.code = data.data.code
          }
        }
      });
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  components: {
    VueQr,payResult
  },
};
</script>

<style lang="scss" scoped>
.selpay {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #d3d3d3;
  padding: 40px;

  .btn {
    display: flex;
    flex-direction: column;
    ::v-deep .el-button--medium {
      font-size: 16px;
    }

    .el-button {
      margin: 20px 0;
      width: 160px;

      i {
        margin-right: 4px;
        font-size: 20px;
        position: relative;
        top: 2px;
      }
    }
  }

  .erweima {
    margin-left: 80px;
    flex: 1;

    .img {
      text-align: center;

      .div {
        width: 140px;
      }
    }

    p {
      margin-top: 22px;
    }
  }
}
</style>
